import React, { useState, useEffect } from "react";
import axios from "../../../../api/axios";
import { MdOutlineCalendarToday } from "react-icons/md";
import Card from "components/card";
import { lineChartOptionsTotalSpent } from "variables/charts";
import LineChart from "components/charts/LineChart";

const TotalSpent = () => {
  const [graphData, setGraphData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("total"); // ✅ default TOTAL

  const storedToken = localStorage.getItem("token");
  const token = "Bearer " + storedToken?.replace(/"/g, "");
  const headers = { Authorization: token };

  // ✅ Load categories (first 7)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("/api/categories", { headers });
        setCategories(response.data.slice(0, 6));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCategories();
  }, []);

  // ✅ Load TOTAL by default
  useEffect(() => {
    const fetchTotal = async () => {
      try {
        const response = await axios.get(
          "/api/dashboard/getgraph-total",
          { headers }
        );
        setGraphData(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    if (selectedCategory === "total") {
      fetchTotal();
    }
  }, [selectedCategory]);

  // ✅ Load by category when selected
  useEffect(() => {
    const fetchByCategory = async () => {
      try {
        const response = await axios.get(
          `/api/dashboard/getgraph-by-category/${selectedCategory}`,
          { headers }
        );
        setGraphData(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    if (selectedCategory !== "total") {
      fetchByCategory();
    }
  }, [selectedCategory]);

  const series = [
    {
      name:
        selectedCategory === "total"
          ? "Totali i Raporteve"
          : categories.find((c) => c.id === selectedCategory)?.name ||
            "Raportet",
      data: graphData || [],
      color: "#4318FF",
    },
  ];

  return (
    <Card extra="!p-[20px] text-center">
      <div className="flex flex-col md:flex-row md:justify-between">
        <button className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-lightPrimary p-2 text-gray-600 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:hover:opacity-90 dark:active:opacity-80">
          <MdOutlineCalendarToday />
          <span className="text-sm font-medium text-gray-600">
            Raporti 1 vjetor
          </span>
        </button>

        {/* ✅ Custom Styled Select */}
        <div className="relative mt-1 md:mt-0">
          <select
            value={selectedCategory}
            onChange={(e) =>
              setSelectedCategory(
                e.target.value === "total"
                  ? "total"
                  : Number(e.target.value)
              )
            }
            className="
              w-48
              rounded-lg
              bg-lightPrimary
              px-2
              py-2
              text-gray-600
              text-sm 
              font-medium 
              focus:outline-none
              focus:ring-0
              dark:bg-navy-700
            "
          >
            <option value="total">Të gjitha kategoritë</option>

            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>

        
        </div>
      </div>

      <div className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
        <div className="h-full w-full">
          <LineChart
            options={lineChartOptionsTotalSpent}
            series={series}
            title="Raportet"
          />
        </div>
      </div>
    </Card>
  );
};

export default TotalSpent;